import { put, takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch } from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectPortfolidetailLast: "[selectPortfolidetailLast] Action",
  selectPortfolidetailLastpage: "[selectPortfolidetailLastpage] Action",
  selectPortfolidetailLastLoad: "[selectPortfolidetailLastLaod] Action",
  selectPortfolidetailLastPageAsync:
    "[selectPortfolidetailLastPageAsync] Action",
  selectPortfolidetailLastAsync: "[selectPortfolidetailLastAsync] Action",
};

const initialState = {
  data: [],
  datapage: [],
  loading: false,
  total: 0,
};

export const select_last_portfolio_detail_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectPortfolidetailLast:
      return {
        ...state,
        data: payload?.data?.results ? payload?.data?.results : [],
        // total:payload?.data?.total ? payload?.data?.total :0
      };
    case actionTypes.selectPortfolidetailLastpage:
      return {
        ...state,
        datapage: payload?.data?.results ? payload?.data?.results : [],
        total: payload?.data?.total ? payload?.data?.total : 0,
      };
    case actionTypes.selectPortfolidetailLastLoad:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectPortfolidetailLastLoad, payload: true });
  let config = {
    url: "select_request",
  };

  let data = {
    table: "portfolio",
    method_type: "select_last_portfolio_detail",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    yield put({
      type: actionTypes.selectPortfolidetailLast,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectPortfolidetailLastLoad,
      payload: false,
    });
  }
}

function* handleWorkerPage({ payload }) {
  // yield put({ type: actionTypes.selectPortfolidetailLastLoad, payload: true });
  let config = {
    url: "select_request",
  };

  let data = {
    table: "portfolio",
    method_type: "select_last_portfolio_detail",
    from: payload.from ? payload.from : 0,
    size: payload.size ? payload.size : 1000,
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    yield put({
      type: actionTypes.selectPortfolidetailLastpage,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    // yield put({ type: actionTypes.selectPortfolidetailLastLoad, payload: false });
  }
}

export function* selectPortfoliodetailLast() {
  yield takeEvery(
    actionTypes.selectPortfolidetailLastPageAsync,
    handleWorkerPage
  );
  yield takeEvery(actionTypes.selectPortfolidetailLastAsync, handleWorker);
}
